import React from "react";
import { useNavigate } from "react-router-dom";
import { handleTopScroll } from "../../../common/function/ScroolTop";

const HeaderBrocdure = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/allbrocedure");
    handleTopScroll()
  };
  return (
    <button
      onClick={() => handleNavigate()}
      className="py-1 px-6 bg-forging-yellow text-md text-white font-semibold hover:text-speed-red md:text-sm sm:text-sm max-sm:text-sm"
    >
   Brochure
    </button>
  );
};

export default HeaderBrocdure;
